import MappingView from 'client/components/Screen/ImportScreen/MappingView/MappingView'
import PickerView from 'client/components/Screen/ImportScreen/PickerView/PickerView'
import { ConnectedScreenProps } from 'client/components/Screen/ScreenConnector'
import { Analytics } from 'client/Global/Analytics'
import { AnalyticsType, Category, Events, Placement, Result } from 'client/Global/AnalyticsEvents'
import { l } from 'client/Other/Translation'
import React from 'react'

import './ImportScreen.scss'

export type ImportTypes = 'CUSTOMER' | 'PRODUCT'
export type ImportSteps = 'Picker' | 'Mapper'

interface ImportScreenProps extends ConnectedScreenProps {
  step: ImportSteps
  type: ImportTypes
}

interface State {
  file: File | null
}
export const ImportScreen: React.FC<ImportScreenProps> = (props) => {
  const [state, setState] = React.useState<State>({ file: null })

  return (
    <div className="Screen Import">
      <h3>
        {l('import.screen.Header')} {props.step === 'Picker' ? 1 : 2}/2
      </h3>
      <div className="Content">
        {props.step === 'Picker' && (
          <PickerView type={props.type} onChange={(file) => setState({ file })} close={props.close} />
        )}
        {props.step === 'Mapper' && <MappingView type={props.type} file={state.file} close={props.close} />}
      </div>
      <div
        className="Close"
        onClick={() => {
          if (props.type === 'CUSTOMER') {
            Analytics.trackEvent(Events.importCustomers, {
              type: AnalyticsType.action,
              category: Category.customer,
              placement: Placement.customers,
              result: Result.cancel,
            })
          }
          if (props.type === 'PRODUCT') {
            Analytics.trackEvent(Events.importProducts, {
              type: AnalyticsType.action,
              category: Category.product,
              placement: Placement.products,
              result: Result.cancel,
            })
          }
          props.close()
        }}
      >
        {l('Close')}
      </div>
    </div>
  )
}
